import cx from "classnames"
import Link from "next/link"
import { getMatchPageUrl } from "../../../../utils/urls"
import { LocalizedMatch } from "../../../../types/match"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"
import { Tabs } from "@components/UI/Tabs"
import { useRouter } from "next/router"

export function MatchMenu({
  isStandingsAvailable,
  selected,
  matchCalciocomSlug,
  match,
}: {
  isStandingsAvailable?: boolean
  selected: string
  matchCalciocomSlug: string
  match: LocalizedMatch
}) {
  const buttons = [
    {
      key: "diretta-live",
      label: "Diretta",
    },
    ...(isStandingsAvailable === true
      ? [
          {
            key: "classifica",
            label: "Classifica",
          },
        ]
      : []),
    {
      key: "statistiche",
      label: "Statistiche",
    },
    {
      key: "precedenti",
      label: "Partite Precedenti",
    },
  ]

  const router = useRouter()

  const handleButtonClick = (key: string) => {
    if (key === "precedenti") {
      router.push(`/squadre/${match.homeTeam?.calciocomSlug}/precedenti/${match.awayTeam?.calciocomSlug}`)
    } else {
      const url = getMatchPageUrl(matchCalciocomSlug, key)
      router.push(url)
    }
  }

  const handleTabChange = (selectedId: string | number) => {
    handleButtonClick(selectedId as string)
  }

  return (
    <div className={style.mainContainer}>
      <Row className={style.container}>
        <Col xs={8} sm={8} md={12} lg={12} xl={12} className={style.linksContainer}>
          {buttons.map(({ key, label }) => {
            if (key === "precedenti") {
              return (
                <div key={key} className={cx(style.link, selected === key && style.active)}>
                  <Link href={`/squadre/${match.homeTeam?.calciocomSlug}/precedenti/${match.awayTeam?.calciocomSlug}`}>
                    <a title={label}>{label}</a>
                  </Link>
                </div>
              )
            }

            const url = getMatchPageUrl(matchCalciocomSlug, key)
            return (
              <div key={key} className={cx(style.link, selected === key && style.active)}>
                <Link href={url}>
                  <a title={label}>{label}</a>
                </Link>
              </div>
            )
          })}
        </Col>
        <Col xs={12} sm={12} md={12} className={style.mobileSelector}>
          <Tabs
            className={`competition-tabs-cc dark`}
            selectedId={selected}
            options={buttons.map((b) => {
              return {
                value: b.key,
                label: b.label,
              }
            })}
            onChange={handleTabChange}
          />
        </Col>
      </Row>
    </div>
  )
}
